import { render, staticRenderFns } from "./index.vue?vue&type=template&id=30c2788e&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=30c2788e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c2788e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/BgUizHzZB/0/snt/info/info-customer/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30c2788e')) {
      api.createRecord('30c2788e', component.options)
    } else {
      api.reload('30c2788e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=30c2788e&scoped=true&", function () {
      api.rerender('30c2788e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Footer/index.vue"
export default component.exports